import React from "react";
import List from "./components/List";
import { MENUS_REQUEST_ACTONS_MAPPING } from "./utils";

export default (props: { match: { params: { path: string; }; }; }) => {
  const MENU_KEY = MENUS_REQUEST_ACTONS_MAPPING[props?.match?.params?.path as keyof typeof MENUS_REQUEST_ACTONS_MAPPING];
  return <List menuKey={MENU_KEY} />;
}
